import EmailTypeSelect from 'EmailComponents/filters/EmailTypeSelect';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { IN } from 'email-management-lib/Shared/utils/filters';
import { BASE_EMAIL_OBJECT_TYPE, HS_TYPES } from 'email-management-lib/refactor/constants/email';
import ListingLibFilterWrapper from 'framework-listing-lib/filters/ListingLibFilterWrapper';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const EMAIL_OBJECT_TYPE_TO_HS_TYPE = {
  [BASE_EMAIL_OBJECT_TYPE.AUTOMATED_EMAIL]: HS_TYPES.AUTOMATED_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.BATCH_EMAIL]: HS_TYPES.BATCH_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.BLOG_EMAIL]: HS_TYPES.BLOG_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.FOLLOWUP_EMAIL]: HS_TYPES.FOLLOWUP_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.AB_EMAIL]: HS_TYPES.AB_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.AUTOMATED_AB_EMAIL]: HS_TYPES.AUTOMATED_AB_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.RSS_EMAIL]: HS_TYPES.RSS_EMAIL,
  [BASE_EMAIL_OBJECT_TYPE.LOCALTIME_EMAIL]: HS_TYPES.LOCALTIME_EMAIL
};
const HS_TYPE_TO_EMAIL_OBJECT_TYPE = {
  [HS_TYPES.AUTOMATED_EMAIL]: BASE_EMAIL_OBJECT_TYPE.AUTOMATED_EMAIL,
  [HS_TYPES.BATCH_EMAIL]: BASE_EMAIL_OBJECT_TYPE.BATCH_EMAIL,
  [HS_TYPES.BLOG_EMAIL]: BASE_EMAIL_OBJECT_TYPE.BLOG_EMAIL,
  [HS_TYPES.FOLLOWUP_EMAIL]: BASE_EMAIL_OBJECT_TYPE.FOLLOWUP_EMAIL,
  [HS_TYPES.AB_EMAIL]: BASE_EMAIL_OBJECT_TYPE.AB_EMAIL,
  [HS_TYPES.AUTOMATED_AB_EMAIL]: BASE_EMAIL_OBJECT_TYPE.AUTOMATED_AB_EMAIL,
  [HS_TYPES.RSS_EMAIL]: BASE_EMAIL_OBJECT_TYPE.RSS_EMAIL,
  [HS_TYPES.LOCALTIME_EMAIL]: BASE_EMAIL_OBJECT_TYPE.LOCALTIME_EMAIL
};
export default function FrameworkEmailTypeFilter() {
  const {
    getQuickFilterValue,
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const hubspotOutageFilter = useSelector(
  // @ts-expect-error Property 'getIn' does not exist on type 'DefaultRootState'.
  state => !!state.getIn(['queryParams', 'outageFilter'], false));
  const handleEmailTypeChange = useCallback(value => {
    if (value.length === 0) {
      removeQuickFilter(PROPERTIES.EMAIL_TYPE);
    } else {
      const types = value.map(v => EMAIL_OBJECT_TYPE_TO_HS_TYPE[v]);
      setQuickFilter(IN(PROPERTIES.EMAIL_TYPE, types));
      types.forEach(type => {
        trackDashboardInteraction({
          action: `filtering-by-email-type-${type}`
        });
      });
    }
  }, [removeQuickFilter, setQuickFilter]);
  const emailTypeValue = useMemo(() => {
    const value = getQuickFilterValue(PROPERTIES.EMAIL_TYPE);
    return value;
  }, [getQuickFilterValue]);
  const ButtonContent = useCallback(() => {
    const count = emailTypeValue ? emailTypeValue.length : 0;
    if (count === 0) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.frameworkTable.filters.emailType.emailTypes"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'email-management.frameworkTable.filters.emailType.typeWithCount',
      options: {
        count
      }
    });
  }, [emailTypeValue]);
  return /*#__PURE__*/_jsx(ListingLibFilterWrapper, {
    active: emailTypeValue && emailTypeValue.length > 0,
    onClearFilter: () => {
      removeQuickFilter(PROPERTIES.EMAIL_TYPE);
    },
    children: /*#__PURE__*/_jsx(EmailTypeSelect, {
      ButtonContent: ButtonContent,
      hubspotOutageFilter: hubspotOutageFilter,
      isUseInFramework: true,
      margin: "0",
      multi: true,
      onChange: handleEmailTypeChange,
      shouldShowLabel: false,
      value: emailTypeValue && emailTypeValue.map(v => HS_TYPE_TO_EMAIL_OBJECT_TYPE[v])
    }, "emailType")
  });
}